/**
 * Validador del dígito verificador del RFC mexicano.
 * Verifica matemáticamente que el último carácter del RFC sea correcto.
 * Detecta RFCs inventados aunque tengan el formato correcto (12 o 13 chars).
 */
const RFC_TABLA = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ';

export function validarDigitoVerificadorRFC(rfc) {
  const r = (rfc || '').toUpperCase().trim();
  if (r.length !== 12 && r.length !== 13) return false;
  const base = r.slice(0, -1);
  const digitoReal = r.slice(-1);
  let suma = 0;
  for (let i = 0; i < base.length; i++) {
    const val = RFC_TABLA.indexOf(base[i]);
    if (val < 0) return false;
    suma += val * (r.length - i);
  }
  const residuo = suma % 11;
  const esperado = residuo === 0 ? '2' : residuo === 1 ? 'A' : String(11 - residuo);
  return digitoReal === esperado;
}
